// src/utils/userExportUtils.js

export function getIdentifiersText(item) {
  if (!item?.identifiers?.length) return "Не указано";

  return item.identifiers.join(", ");
}

export function getSubscriptionHistoryText(history) {
  if (!Array.isArray(history) || history.length === 0) return "—";

  return history
    .map((p) => `${formatDate(p.start)} - ${formatDate(p.end)}`)
    .join("\n");
}

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  return isNaN(date) ? "—" : date.toLocaleDateString("ru-RU");
}
